import { ApiAPITokenType, ApiProject } from "@incendium/api";
import { Divider, Stack, Typography } from "@mui/material";
import AccordianGlassCard from "Components/UI/AccordianGlassCard";
import APITokenCard from "features/dataConnectors/components/APITokenCard";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";
import Woo from "Assets/Images/ThirdParty/woocommerce-logo-color-black@2x.png";
import { useState } from "react";
import { PlatformURL } from "config";
import CopyClipboardBtn from "Components/CopyClipboardBtn/CopyClipboardBtn";

interface IOnboardingWoocmerceProps {
  project: ApiProject;
  isWooCommerce: boolean;
}

function OnboardingWoocmerce({ project, isWooCommerce }: IOnboardingWoocmerceProps) {
  const [pixelOpen, setPixelOpen] = useState(true);
  return (
    <Stack spacing={4}>
      <AccordianGlassCard
        onOpenChange={(b) => setPixelOpen(b)}
        defaultClosed={!pixelOpen}
        title={
          <Typography variant="subtitle1">
            User the Incendium Plugin (recomended)
          </Typography>
        }
      >
        <Typography variant="body1" mb={2}>
          The best and easiest way to install Incendium is to use our wordpress plugin
        </Typography>
        <Typography variant="body1">
          To install the plugin, go to the plugins page in your wordpress admin and click add new. Search for Incendium and click install now. Once installed, click activate.
          alternatively, you can download the plugin from https://wordpress.org/plugins/incendium/ and upload it manually.
        </Typography>


        <Typography variant="body1" gutterBottom>
          Once the plugin is installed, you will need to go to the Incendium settings page and enter your Environment and Project key which can be found below.
        </Typography>
        <Typography variant="body1">
          Project Key:  <Typography variant="body1" component="span" color={"primary.main"}>{project.key}  <CopyClipboardBtn
            color="primary"
            text={`${project.key}`}
            stopPropagation
            isIconButton
            size="small"
          /></Typography>
        </Typography>
        <Typography variant="body1">
          Environment: <Typography variant="body1" component="span" color={"primary.main"}>{PlatformURL.split('.')[0].replace('https://', '').replace('http://', '')} <CopyClipboardBtn
            color="primary"
            text={`${PlatformURL.split('.')[0].replace('https://', '').replace('http://', '')}`}
            stopPropagation
            isIconButton
            size="small"
          /></Typography>
        </Typography>

        {isWooCommerce && (
          <>
            <Divider />
            <Typography variant="body1" my={2}>
              For WooCommerce, you will need to generate an API token to connect to the Incendium API.
            </Typography>
            <Typography variant="body1" my={2}>
              Click the generate button below to generate an API token. Once generated, you will need to add the API token to your Wordpress store in the Incendium settings page.
            </Typography>
            <APITokenCard
              title="WooCommerce API Token"
              type={ApiAPITokenType.API_TOKEN_TYPE_WOOCOMMERCE}
              clientId={project.clientId as number}
              projectId={project.id as number}
              projectKey={project.key || ""}
              logo={Woo}
              imageSx={{ maxHeight: 35 }}
              info={
                <Typography variant="body2" color={"text.secondary"}>
                  Selecting this will generate an auth key. Use this key for
                  Woocommerce.
                </Typography>
              }
            />
          </>
        )}
      </AccordianGlassCard>
      <AccordianGlassCard
        onOpenChange={(b) => setPixelOpen(b)}
        defaultClosed
        title={
          <Typography variant="subtitle1">
            Manual Install Incendium
          </Typography>
        }
      >
        <Typography variant="body1" mb={2}>
          You can add the Incendium Pixel to your wordpress site manually or
          via Google Tag Manager (GTM).{" "}
        </Typography>
        <Typography variant="body1">
          Option 1: Add Manually Log in to your WordPress Admin. Go to
          Appearance {">"} Theme File Editor. In the right-hand list, locate and
          click header.php (inside your active theme folder). Paste the
          Incendium Pixel script just before the {"</head>"} closing tag. Click
          Update File to save changes.
        </Typography>
        <Typography variant="body1" mb={5}>
          Option 2: Add via Google Tag Manager Log in to Google Tag Manager
          (GTM). Click Tags{" >"} New. Select Custom HTML as the tag type. Paste
          the Incendium Pixel script. Under Triggering, choose All Pages. Click
          Save, then Submit & Publish the container.
        </Typography>

        <ProjectCodeSnippet project={project} />
      </AccordianGlassCard>
    </Stack>
  );
}

export default OnboardingWoocmerce;
